import React from "react";
import { Button } from "react-bootstrap";
import { PlusLg } from "react-bootstrap-icons";

interface AddButtonProps {
    onClick: any;
    size: "sm" | "lg" | undefined
}

export default function AddButton(props: AddButtonProps) {

    return (
        <div>
            <Button
                size={props.size}
                variant='outline-success'
                onClick={(event) => { props.onClick?.(event) }}>
                <PlusLg></PlusLg>
            </Button>
        </div>
    );
}